(function () {
  function normalize(value) {
    return (value || '')
      .toString()
      .toLocaleLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\p{L}\p{N}]+/gu, ' ')
      .trim();
  }

  function init(directory) {
    if (directory.__faqDirectoryInitialized) return;
    directory.__faqDirectoryInitialized = true;

    var search = directory.querySelector('[data-faq-search]');
    var clear = directory.querySelector('[data-faq-clear]');
    var reset = directory.querySelector('[data-faq-reset]');
    var status = directory.querySelector('[data-faq-status]');
    var empty = directory.querySelector('[data-faq-empty]');
    var items = Array.prototype.slice.call(directory.querySelectorAll('[data-faq-item]'));
    var categories = Array.prototype.slice.call(directory.querySelectorAll('.faq-directory__category[data-faq-category]'));
    var categoryList = directory.querySelector('[data-faq-category-list]');
    var scrub = directory.querySelector('[data-faq-scrub]');
    var scrubTrack = directory.querySelector('[data-faq-scrub-track]');
    var scrubHandle = directory.querySelector('[data-faq-scrub-handle]');
    var selectedCategory = '';
    var params = new URLSearchParams(window.location.search);
    var singularLabel = status.getAttribute('data-singular-label');
    var pluralLabel = status.getAttribute('data-plural-label');
    var foundLabel = status.getAttribute('data-found-label');

    function updateUrl(replace) {
      var next = new URL(window.location.href);
      if (search.value.trim()) next.searchParams.set('q', search.value.trim());
      else next.searchParams.delete('q');
      if (selectedCategory) next.searchParams.set('category', selectedCategory);
      else next.searchParams.delete('category');
      window.history[replace ? 'replaceState' : 'pushState']({}, '', next);
    }

    function updateCategoryScrub() {
      if (!scrub || !categoryList || !scrubTrack || !scrubHandle) return;
      var max = Math.max(0, categoryList.scrollWidth - categoryList.clientWidth);
      if (max <= 2) {
        scrub.hidden = true;
        return;
      }
      scrub.hidden = false;
      var range = scrubTrack.clientWidth - scrubHandle.offsetWidth;
      var progress = categoryList.scrollLeft / max;
      scrubHandle.style.transform = 'translateX(' + Math.max(0, range * progress) + 'px)';
      scrubHandle.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
    }

    function initCategoryScrub() {
      if (!scrub || !categoryList || !scrubTrack || !scrubHandle) return;
      var drag = null;
      function scrollByTopic(direction) {
        var firstCategory = categories[0];
        var styles = window.getComputedStyle ? window.getComputedStyle(categoryList) : null;
        var gap = styles ? parseFloat(styles.columnGap || styles.gap) || 0 : 0;
        var distance = firstCategory ? firstCategory.getBoundingClientRect().width + gap : categoryList.clientWidth * 0.8;
        var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        categoryList.scrollBy({ left: distance * direction, behavior: reducedMotion ? 'auto' : 'smooth' });
      }

      scrubHandle.addEventListener('pointerdown', function (event) {
        drag = { x: event.clientX, left: categoryList.scrollLeft };
        if (scrubHandle.setPointerCapture) scrubHandle.setPointerCapture(event.pointerId);
        scrub.classList.add('is-dragging');
        event.preventDefault();
      });
      scrubHandle.addEventListener('pointermove', function (event) {
        if (!drag) return;
        var range = scrubTrack.clientWidth - scrubHandle.offsetWidth;
        var max = Math.max(0, categoryList.scrollWidth - categoryList.clientWidth);
        if (range > 0 && max > 0) categoryList.scrollLeft = drag.left + (event.clientX - drag.x) * (max / range);
      });
      function endDrag() {
        drag = null;
        scrub.classList.remove('is-dragging');
      }
      scrubHandle.addEventListener('pointerup', endDrag);
      scrubHandle.addEventListener('pointercancel', endDrag);
      scrub.addEventListener('pointerdown', function (event) {
        if (event.target === scrubHandle || drag) return;
        var rect = scrubTrack.getBoundingClientRect();
        var range = rect.width - scrubHandle.offsetWidth;
        if (range <= 0) return;
        var ratio = Math.max(0, Math.min(1, (event.clientX - rect.left - scrubHandle.offsetWidth * 0.5) / range));
        categoryList.scrollTo({ left: ratio * Math.max(0, categoryList.scrollWidth - categoryList.clientWidth), behavior: 'smooth' });
      });
      scrubHandle.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          scrollByTopic(event.key === 'ArrowLeft' ? -1 : 1);
          event.preventDefault();
        }
      });
      categoryList.addEventListener('scroll', updateCategoryScrub, { passive: true });
      if ('ResizeObserver' in window) {
        var observer = new window.ResizeObserver(updateCategoryScrub);
        observer.observe(categoryList);
        observer.observe(scrubTrack);
      } else {
        window.addEventListener('resize', updateCategoryScrub);
      }
      updateCategoryScrub();
    }

    function applyFilters(updateHistory, replaceHistory) {
      var query = normalize(search.value);
      var visible = 0;
      items.forEach(function (item) {
        var haystack = normalize(item.getAttribute('data-faq-search'));
        var matchesQuery = !query || haystack.indexOf(query) !== -1;
        var matchesCategory = !selectedCategory || item.getAttribute('data-faq-category') === selectedCategory;
        var matches = matchesQuery && matchesCategory;
        item.hidden = !matches;
        if (matches) visible += 1;
      });

      clear.hidden = !search.value;
      empty.hidden = visible !== 0;
      status.textContent = visible === items.length && !query && !selectedCategory
        ? status.getAttribute('data-default-label')
        : visible + ' ' + (visible === 1 ? singularLabel : pluralLabel) + ' ' + foundLabel;
      if (updateHistory) updateUrl(replaceHistory);
    }

    function chooseCategory(button, pushState) {
      selectedCategory = button.getAttribute('data-faq-category') || '';
      categories.forEach(function (category) {
        var active = category.getAttribute('data-faq-category') === selectedCategory;
        category.classList.toggle('is-active', active);
        category.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      applyFilters(pushState, false);
    }

    function resetFilters(pushState) {
      search.value = '';
      chooseCategory(categories[0], false);
      applyFilters(false, false);
      if (pushState) updateUrl(false);
      search.focus();
    }

    status.setAttribute('data-default-label', status.textContent.trim());
    initCategoryScrub();
    search.value = params.get('q') || '';
    var initialCategory = params.get('category') || '';
    var initialButton = categories.find(function (button) {
      return button.getAttribute('data-faq-category') === initialCategory;
    }) || categories[0];
    chooseCategory(initialButton, false);
    applyFilters(false, false);

    search.addEventListener('input', function () { applyFilters(true, true); });
    clear.addEventListener('click', function () {
      search.value = '';
      applyFilters(true, true);
      search.focus();
    });
    reset.addEventListener('click', function () { resetFilters(true); });
    categories.forEach(function (category) {
      category.addEventListener('click', function () { chooseCategory(category, true); });
    });
    window.addEventListener('popstate', function () {
      var current = new URLSearchParams(window.location.search);
      search.value = current.get('q') || '';
      var button = categories.find(function (category) {
        return category.getAttribute('data-faq-category') === (current.get('category') || '');
      }) || categories[0];
      chooseCategory(button, false);
      applyFilters(false, false);
    });
  }

  function boot() {
    document.querySelectorAll('[data-faq-directory]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
